import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultClientRightsAndResponsbilities = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultClientRightsAndResponsbilities' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b> <center> CLIENT RIGHTS & RESPONSIBILITIES  </center> </b>
                </p>
                <p className='w-750'>
                    <b> Policy :</b> It is the policy of Jackson Hands of Change to protect the rights of each client. During the intake process, the client's rights are reviewed in a manner that is understandable and staff respond to questions and grievances pertaining to these rights.  The agency ensures compliance with client's rights enumerated in R.S. 28:171; and ensure compliance with minor's rights in the Louisiana Children's Code article 1409.
                </p>
                <p className='w-750'>
                    <b> CLIENT RIGHTS:</b>

                    <ol>
                        <li>to be informed of the client's rights and responsibilities at the time of admission or within 24 hours of admission;</li>
                        <li>to have a family member, chosen representative and/or his or her own physician notified of admission to the agency at the request of the client;</li>
                        <li>to receive treatment and medical services without discrimination based on race, age, religion, national origin, gender, sexual orientation, or disability;</li>
                        <li>to maintain the personal dignity of each client;</li>
                        <li>to be free from abuse, neglect, exploitation and harassment;</li>
                        <li>to receive care in a safe setting;</li>
                        <li>to receive the services of a translator or interpreter, if applicable, to facilitate communication between the client and the staff;</li>
                        <li>to be informed of the client's own health status and to participate in the development, implementation and updating of the client's treatment plan;</li>
                        <li>to make informed decisions regarding the client's care by the client or the client's parent or guardian, if applicable, in accordance with federal and state laws and regulations;</li>
                        <li>to participate or refuse to participate in experimental research when the client gives informed, written consent to such participation, or when a client's parent or legal guardian provides such consent, when applicable, in accordance with federal and state laws and regulations;</li>


                        <li>to be informed, in writing, of the policies and procedures for filing a grievance and their review and resolution;</li>
                        <li>to submit complaints or grievances without fear of reprisal;</li>
                        <li>to have the client's information and medical records, including all computerized medical information, kept confidential in accordance with federal and state statutes and rules/regulations;</li>
                        <li>to be given a copy of the program's rules and regulations upon admission;</li>
                        <li>to receive treatment in the least restrictive environment that meets the client's needs;</li>
                        <li>to not be restrained or secluded in violation of federal and state laws, rules and regulations;</li>
                        <li>to be informed in advance of all estimated charges and any limitations on the length of services at the time of admission or within 72 hours;</li>
                        <li>to receive an explanation of treatment or rights while in treatment; 19. </li>
                        <li>
                            to be informed of the:
                            <ol type='a'>
                                <li>nature and purpose of any services rendered;</li>
                                <li>the title of personnel providing that service;</li>
                                <li>the risks, benefits, and side effects of all proposed treatment and medications;</li>
                                <li>the probable health and mental health consequences of refusing treatment; and</li>
                                <li>other available treatments which may be appropriate;</li>
                            </ol>
                        </li>
                        <li>to accept or refuse all or part of treatment, unless prohibited by court order or a physician deems the client to be a danger to self or others or gravely disabled; </li>
                        <li>to have a copy of these rights, which includes the information to contact HSS during routine business hours at: Address: 628 N 4th St, Baton Rouge, LA 70802 Phone: (225) 342-0138 </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b> CLIENT RESPONSIBILITIES:</b> To make your mental health treatment successful, we need to work together. The agency asks that all clients provide clear, complete and truthful information at all times. We do our part by providing you with information concerning your rights and the services we offer.  Your part is to take responsibility for the following:
                    <ol>
                        <li>Follow agency rules, policies and procedures.</li>
                        <li>Follow the steps described in this handbook if you wish to file a grievance or appeal with our agency.</li>
                        <li>Keep scheduled appointments and call to cancel or reschedule if you cannot make your scheduled appointment.</li>
                        <li>Ask questions when you don't understand or when you want more information.</li>
                        <li>Provide any information to your worker that is necessary for your treatment.</li>
                        <li>Participate actively to create goals that will help you in your recovery.</li>
                        <li>Follow the treatment plans that you and your providers have agreed upon.</li>
                        <li>Take medications as they are prescribed for you.</li>
                        <li>Tell your doctor if you are having unpleasant side effects from your medications, or if your medications do not seem to be working to help you feel better.</li>
                        <li>Seek out additional support services in the community.</li>
                        <li>Invite the people (family, friends, etc.) who will be helpful and supportive to you to be included in your treatment.</li>
                        <li>Understand your rights and the grievance process.</li>
                        <li>Treat staff, as you would expect to be treated. </li>
                    </ol>
                </p>
                <p className='w-750'>
                    I understand the person responsible for coordination services for me is:
                    <input type='text' id='txtPersonResponsible' name='txtPersonResponsible' className='add-only w-200 custom-add-only' />
                    , whose credentials have been explained to me.

                </p>
                <p className='w-750'>
                    <b>
                        THE ABOVE INFORMATION HAS BEEN EXPLAINED TO ME AND I HAVE HAD AN OPPORTUNITY TO ASK QUESTIONS WHICH HAVE BEEN ANSWERED TO MY SATISFACTION.</b>

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}